import React, { useState } from 'react';

import PropertyComponent from './PropertyComponent';
import PropertyModal from './PropertyModal';

const ControlProperty = ({
  label,
  name,
  type,
  values,
  controlId,
  entitySourceField,
  dependentProperties,
}) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <PropertyComponent
        type={type}
        controlId={controlId}
        values={values}
        name={name}
        label={label}
        onOpen={() => setOpenModal(true)}
        entitySourceField={entitySourceField}
        dependentProperties={dependentProperties}
      />
      {openModal && (
        <PropertyModal
          label={label}
          controlId={controlId}
          name={name}
          onClose={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default ControlProperty;
